import { Tag } from '@/core/tamagoshi/Tag/Tag';
import { translations } from '@/domains/productDiscovery/ProductCard/translations';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';

export const HeaderTags = () => {
  const { isOnTopSale, isBestQualityOffer } = useDetail();

  if (isOnTopSale)
    return (
      <div>
        <Tag color="yellow">{translations.tags.topSale.label}</Tag>
      </div>
    );

  if (isBestQualityOffer) {
    return (
      <div>
        <Tag color="darkBlue">{translations.tags.bestQualityOffer.label}</Tag>
      </div>
    );
  }

  return null;
};
